import { render, staticRenderFns } from "./CarouselPage.vue?vue&type=template&id=1f6acf96&scoped=true"
import script from "./CarouselPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CarouselPage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CarouselPage.vue?vue&type=style&index=0&id=1f6acf96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.16_css-loader@6.11.0_webpack@5.99.9__lodash@4._400fd893165f8898ec34f2f453564d40/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6acf96",
  null
  
)

export default component.exports